import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import type { LoginStore } from '../stores/user/login-store';
import { UserLoginParams } from '../types/stores/login-store-type';

@singleton()
export class LoginStoreFacade {
  originalStore: LoginStore;

  constructor() {
    this.originalStore = container.resolve<LoginStore>('loginStore');
  }

  public get ks() {
    return this.originalStore.ks;
  }

  public get isSilentLogin() {
    return this.originalStore.isSilentLogin;
  }

  public get userCode() {
    return this.originalStore.userCode;
  }

  public get isAnonymous() {
    return this.originalStore.isAnonymous;
  }

  public get isPostLoginProcessing() {
    return this.originalStore.isPostLoginProcessing;
  }

  public get jwtToken() {
    return this.originalStore.jwtToken;
  }

  public get verificationUri() {
    return this.originalStore.verificationUri;
  }

  public get userMigrationUri() {
    return this.originalStore.userMigrationUri;
  }

  public get prepareOAuthLogin() {
    return this.originalStore.prepareOAuthLogin;
  }

  /**
   *  In case with external login you should provide `{oauth:OAuthParams}` (mobile, web). For authorize by pin code you should invoke without params (stb, smart).
   *  For SSO or OTT authorize by username and password you should provide `{form: FormParams}`.
   * @param params: UserLoginParams
   * @returns token
   */
  @action.bound
  public async userLogin(params?: UserLoginParams) {
    return this.originalStore.userLogin(params);
  }

  /**
   *  For logout user from the system
   * @param deleteUser: boolean
   * @param clearApplicationRoute: boolean
   * @returns Promise<void>
   */
  @action.bound
  public async logoutUser(deleteUser?: boolean, clearApplicationRoute?: boolean) {
    return this.originalStore.logoutUser(deleteUser, clearApplicationRoute);
  }

  /**
   *  In order to reset password invoke
   * @param email: string
   */
  @action.bound
  public async ssoResetPassword(email: string) {
    return this.originalStore.ssoResetPassword(email);
  }

  /**
   * Should be invoked STB and SmartTV on back button press.
   */
  @action.bound
  public loginPinStop() {
    return this.originalStore.loginPinStop();
  }
}
